import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Editor } from '@tinymce/tinymce-react';
import {
  FormGroup, Label, Input,
} from 'reactstrap';
import { map } from 'lodash';
import moment from 'moment';
import { staticConstants } from '../../../../utils';
import InputError from '../../../shared/elments/InputError';

function CampaignTimeLine(props) {
  const {
    campaignTimeline, errors, register, handleRemove, handleChangeTitle, handleChangeHashtag,
    handleEditorChange, handleFromDate, handleShareTimeLine, isOfferPublished, isPublishedOfferEditable,
  } = props;
  const renderCampaignTimeline = () => {
    const selectMinStartDate = moment(new Date()).add(1, 'days').toDate();
    return map(campaignTimeline, (item, index) => item && (
    <div className="create-offer-timeline-box" key={`${item}-${index}`}>
      <div className="create-offer-timeline-wrapper">
        <h4>
          Segment
          {' '}
          {index + 1}
          {' '}
          of campaign
        </h4>
        <div className="campaign-wrapper">
          <div className="datepicker-wrapper">
            <FormGroup className={errors[`startDate-${index}`] ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Label
                for="startDate"
              >
                Start on
              </Label>
              <DatePicker
                placeholderText="Start date"
                className="form-control"
                dateFormat="MMMM dd"
                name={`startDate-${index}`}
                selected={item[`startDate-${index}`]}
                minDate={selectMinStartDate}
                disabled={isOfferPublished && !isPublishedOfferEditable}
                onChange={(e) => handleFromDate(e, 'startDate', index)}
                autoComplete="off"
              />
              <InputError error={errors[`startDate-${index}`]} />
            </FormGroup>
            <FormGroup className={errors[`endDate-${index}`] ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Label
                for="endDate"
              >
                End on
              </Label>
              <DatePicker
                placeholderText="End date"
                className="form-control"
                name={`endDate-${index}`}
                dateFormat="MMMM dd"
                selected={item[`endDate-${index}`]}
                onChange={(e) => handleFromDate(e, 'endDate', index)}
                minDate={selectMinStartDate}
                disabled={isOfferPublished && !isPublishedOfferEditable}
                autoComplete="off"
              />
              <InputError error={errors[`endDate-${index}`]} />
            </FormGroup>
          </div>
          <div className="social-wrapper">
            <FormGroup>
              <Label
                for="shared"
              >
                To be shared on
              </Label>
              <div className="modal-request-account-social-icons">
                <label htmlFor={`facebook-${index}`} className="input-container-green">
                  <Input
                    name={`facebook-${index}`}
                    id={`facebook-${index}`}
                    type="checkbox"
                    checked={item[`shareType-${index}`][0][`facebook-${index}`]}
                    onClick={(event) => { handleShareTimeLine(event, index); }}
                  />
                  <span className="social-icon facebook" />
                </label>
                <label htmlFor={`twitter-${index}`} className="input-container-green">
                  <Input
                    name={`twitter-${index}`}
                    id={`twitter-${index}`}
                    type="checkbox"
                    checked={item[`shareType-${index}`][0][`twitter-${index}`]}
                    onClick={(event) => { handleShareTimeLine(event, index); }}
                  />
                  <span className="social-icon twitter" />
                </label>
                <label htmlFor={`instagram-${index}`} className="input-container-green">
                  <Input
                    name={`instagram-${index}`}
                    id={`instagram-${index}`}
                    type="checkbox"
                    checked={item[`shareType-${index}`][0][`instagram-${index}`]}
                    onClick={(event) => { handleShareTimeLine(event, index); }}
                  />
                  <span className="social-icon instagram" />
                </label>
                <label htmlFor={`youtube-${index}`} className="input-container-green">
                  <Input
                    name={`youtube-${index}`}
                    id={`youtube-${index}`}
                    type="checkbox"
                    checked={item[`shareType-${index}`][0][`youtube-${index}`]}
                    onClick={(event) => { handleShareTimeLine(event, index); }}
                  />
                  <span className="social-icon youtube" />
                </label>
                <label htmlFor={`spotify-${index}`} className="input-container-green">
                  <Input
                    name={`spotify-${index}`}
                    id={`spotify-${index}`}
                    type="checkbox"
                    checked={item[`shareType-${index}`][0][`spotify-${index}`]}
                    onClick={(event) => { handleShareTimeLine(event, index); }}
                  />
                  <span className="social-icon spotify" />
                </label>
              </div>
              <InputError error={errors[`shareType-${index}`]} />
            </FormGroup>
          </div>
        </div>
        <FormGroup>
          <Label
            for="Title"
          >
            Campaign title(optional)
          </Label>
          <Input
            id={`campaignTitle-${index}`}
            type="text"
            name="campaignTitle"
            placeholder="Enter title"
            value={item[`campaignTitle-${index}`]}
            onChange={(e) => handleChangeTitle(e, index)}
          />
        </FormGroup>
        <FormGroup className={`editor-container ${errors[`description-${index}`] ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}`}>
          <Label
            for="Description"
          >
            Opportunity description
          </Label>
          <Editor
            className="editorContainer"
            name={`description-${index}`}
            init={{
              height: '400px',
              width: '100%',
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar: 'bold italic underline forecolor alignleft aligncenter alignright numlist insertfile link image | a11ycheck ltr rtl |',
            }}
            value={item[`description-${index}`]}
            onEditorChange={(e) => { handleEditorChange(e, index); }}
          />
          <InputError error={errors[`description-${index}`]} />
        </FormGroup>
        <FormGroup className={errors[`hashTag-${index}`] ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
          <Label
            for="Hashtags"
          >
            Hashtags to be added
          </Label>
          <Input
            type="text"
            id={`hashTag-${index}`}
            name={`hashTag-${index}`}
            placeholder="Hashtags to be added"
            value={item[`hashTag-${index}`] || ''}
            onChange={(e) => handleChangeHashtag(e, index)}
          />
          <InputError error={errors[`hashTag-${index}`]} />
        </FormGroup>
        {index > 0 && (
        <div className="create-offer-timeline-btn-wrapper btn-remove">
          <span className={`${isOfferPublished && 'disabled'}`} onClick={() => handleRemove(index)}>Remove</span>
        </div>
        )}
      </div>
    </div>
    ));
  };
  return (
    <>
      {renderCampaignTimeline()}
    </>
  );
}

CampaignTimeLine.propTypes = {
  campaignTimeline: PropTypes.arrayOf(PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    description: PropTypes.string,
    shareType: PropTypes.shape({
      facebook: PropTypes.bool,
      instagram: PropTypes.bool,
      twitter: PropTypes.bool,
      spotify: PropTypes.bool,
      youtube: PropTypes.bool,
    }),
  })).isRequired,
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  handleChangeTitle: PropTypes.func.isRequired,
  handleChangeHashtag: PropTypes.func.isRequired,
  handleEditorChange: PropTypes.func.isRequired,
  handleFromDate: PropTypes.func.isRequired,
  handleShareTimeLine: PropTypes.func.isRequired,
  isOfferPublished: PropTypes.bool,
  isPublishedOfferEditable: PropTypes.bool,
};

CampaignTimeLine.defaultProps = {
  isOfferPublished: false,
  isPublishedOfferEditable: false,
};

export default CampaignTimeLine;
